import CallToAction from '../../cta/cta.vue';
import BaseVueComponent from '../../_imports/shared/base-vue-component.vue.common';
import FormUtils from '../_imports/shared/form-utils.vue.common';
import FormsField from '../_imports/forms-field.vue';
import FormsFieldset from '../_imports/forms-fieldset.vue';
import FormsFieldComponents from '../_imports/shared/forms-field-components.vue.common';
import { sanitizeHtml } from '../../_imports/shared/vue-utils.common';
import initGetUtmFromUrl from '../../_imports/loadMktoUtms';
import formStore from './store/form';

export default {
    mixins: [
        BaseVueComponent,
        FormUtils,
        FormsFieldComponents,
        sanitizeHtml
    ],
    components: {
        CallToAction,
        FormsField,
        FormsFieldset
    },
    props: {
        formTitle: String,
        submitLabel: String,
        overrideThankYouMessage: String
    },
    data() {
        return {
            verifyEmailFirst: false,
            alwaysAskEmail: false,
            fieldsAreVisible: true,
            rootBaseClasses: [],
            contentBaseClasses: [],
            events: [],
            fullyLoaded: false,
            state: {}
        };
    },
    provide() {
        return {
            getForm: () => this,
            getFormEvent: () => this.getEventDto_()
        };
    },
    created() {
        this.handleEvents_();
    },
    mounted() {
        initGetUtmFromUrl();

        this.$nextTick(() => {
            this.$el.classList.add('component-is-mounted');

            this.fullyLoaded = true;
        });
    },
    computed: {
        formContentBaseClasses() {
            return this.contentBaseClasses.join(' ');
        },
        formRootBaseClasses() {
            return this.rootBaseClasses.join(' ');
        },
        buttonFields() {
            return this.registeredFields.filter(field => this.isFieldSubmitButton(field));
        },
        baseFieldsToRender() {
            return this.data.fields.filter((field) => this.isFieldToFill(field) && !this.isVisibleWithEmailFirst(field));
        },
        registeredFields() {
            const fields = [];

            this.data.fields.forEach(field => {
                if (this.isFieldFieldset(field)) {
                    fields.push(...field.fields);
                } else {
                    fields.push({ ...field });
                }
            });

            return fields;
        },
        registeredFieldsToFill() {
            return this.registeredFields.filter(field => this.isFieldToFill(field));
        },
        afterFormFields() {
            const lastButtonFieldIndex = this.buttonFields[this.buttonFields.length - 1];

            if (lastButtonFieldIndex >= 0) {
                return this.registeredFields.splice(lastButtonFieldIndex + 1, this.registeredFields.length);
            }

            return [];
        },
        emailFields() {
            return this.registeredFields.filter(field => this.isFieldEmail(field));
        },
        hiddenFields() {
            return this.registeredFields.filter(field => this.isFieldHidden(field));
        },
        visibleWithEmailFirstFields() {
            return this.registeredFields.filter(field => (this.isVisibleWithEmailFirst(field)));
        },
        disclaimerFields() {
            return this.registeredFields.filter(field => this.isFieldDisclaimer(field));
        },
        fieldErrorMessages() {
            return this.data.fieldErrorMessages;
        },
        submitButtonLabel() {
            return this.state.formSubmitLabel;
        }
    },
    methods: {
        handleSubmit_(e) {
            e.preventDefault();

            this.beginSubmitForm_();
        },
        handleCountrySelectFieldStateUpdate_(field) {
            if (field.isValid) {
                this.updateState(state => {
                    state.formCountry = field.state.userInput
                });
            }
        },
        handleEmailFieldStateUpdate_(field) {
            if (field.isValid) {
                this.updateState(state => state.emailIsFilled = true);

                if (this.onValidEmail) {
                    this.onValidEmail(field.state.userInput);
                }
            } else {
                this.updateState(state => state.emailIsFilled = false);
            }
        },
        handleEvents_() {
            this.$root.$on('focusfield', this.onFieldFocus_);
            this.$root.$on('register-field', this.onFieldRegister_);
            this.$root.$on('state-update', this.onFieldStateUpdate_);
            this.$root.$on('submit', this.beginSubmitForm_);
            this.$root.$on('update-form-submit-label', this.updateFormSubmitLabel_);

            window.addEventListener('updatefieldvalue', event => {
                this.sendEventWithName('updatefieldvalue', {
                    ...event.detail
                });
            });
        },
        handleSpecialFieldStateUpdate_(field) {
            if (this.isFieldEmail(field)) {
                this.handleEmailFieldStateUpdate_(field);
            } else if (this.isFieldCountrySelect(field)) {
                this.handleCountrySelectFieldStateUpdate_(field);
            }
        },
        getEventByName_(eventName) {
            return this.events.find(event => event.name === eventName);
        },
        getEventDto_() {
            return {
                dispatch: (eventName, eventPayload = null) => {
                    this.$emit(eventName, eventPayload);
                },
                on: (eventName, callback) => {
                    eventName = eventName.toLowerCase();

                    const event = this.getEventByName_(eventName);

                    if (event) {
                        event.listeners.push(callback);
                    } else {
                        this.events.push({
                            name: eventName,
                            listeners: [callback]
                        });
                    }
                }
            };
        },
        isFieldToFill(field) {
            if (this.verifyEmailFirst
                && field.type === 'email') {
                return false;
            }

            return field.type !== 'hidden'
                && field.type !== 'submit'
                && !this.afterFormFields.includes(field);
        },
        onFieldFocus_(field) {
            if (field) {
                this.sendEventWithName('blurfields', {
                    exceptions: [field.name]
                });
            }
        },
        onFieldRegister_(field) {
            if (field
                && !this.registeredFields.some(registeredField => registeredField.fieldId === field.fieldId)) {
                this.registeredFields.push({ ...field });
            }
        },
        onFieldStateUpdate_(fieldState) {
            this.updateFieldData_(fieldState);
        },
        sendEvent_(event, eventData = {}) {
            if (event) {
                event.listeners.forEach(listener => listener(eventData));
            }
        },
        beginSubmitForm_(eventPayload = {}) {
            if (this.isUserTyping()) {
                const interval = setInterval(() => {
                    if (!this.isUserTyping()) {
                        clearInterval(interval);
                        this.submitForm_(eventPayload);
                    }
                }, 100);
            } else {
                this.submitForm_(eventPayload);
            }
        },
        submitForm_(eventPayload = {}) {
            if (this.state.formIsSubmitting) {
                return;
            }

            this.updateState(state => {
                state.formIsSubmitting = false;
                state.formSubmitSuccess = false;
                state.formSubmitError = false;
                state.formReadyForSubmit = false;
            });

            this.sendEventWithName('validatefields');

            this.$nextTick(() => {
                this.validateFields();

                if (!this.state.formReadyForSubmit) {
                    return;
                }

                this.updateState(state => state.formIsSubmitting = true);

                const fields = {};

                this.registeredFields.forEach(field => {
                    if (this.isFieldValidForSubmission(field)) {
                        fields[field.name] = field.userInput;
                    }
                });

                this.data.additionalData?.forEach(field => {
                    fields[field.name] = field.value;
                });

                for (const field in fields) {
                    fields[field] = this.sanitizeHtml(fields[field]);
                }

                const form = {
                    fields,
                    success: () => {
                        this.updateState(state => {
                            state.formIsSubmitting = false;
                            state.formSubmitSuccess = true;
                        });

                        this.$emit('success');
                    },
                    error: () => {
                        this.updateState(state => {
                            state.formIsSubmitting = false;
                            state.formSubmitError = true;
                        });
                    }
                };

                if (this.onSubmitForm) {
                    this.onSubmitForm(form);
                }
            });
        },
        updateBaseClasses_(classesSource, baseClass, baseCondition) {
            if (baseCondition
                && !this[classesSource].includes(baseClass)) {
                this[classesSource].push(baseClass);
            } else {
                this[classesSource] = this[classesSource].filter(classSource => classSource !== baseClass);
            }
        },
        updateFieldData_(fieldState) {
            const field = this.registeredFields.find(f => f.fieldId === fieldState.fieldId);

            if (field
                && JSON.stringify(field.state) !== JSON.stringify(fieldState)) {
                if (field.userInput !== fieldState.userInput) {
                    const eventPayload = {
                        id: field.fieldId,
                        name: field.name,
                        value: fieldState.userInput
                    };

                    this.sendEventWithName('fieldvalueupdated', eventPayload);

                    window.dispatchEvent(new CustomEvent('fieldvalueupdated', {
                        detail: eventPayload
                    }));
                }

                field.state = fieldState;
                field.ignore = field.state.ignore;
                field.isEnriched = field.state.isEnriched;
                field.isValid = field.state.isValid;
                field.userInput = field.state.userInput;
                field.userTyping = field.state.userTyping || false;
                field.connected = field.state.connected;

                if (field.name !== field.state.name) { // maybe do that for all fields
                    field.name = field.state.name;
                }

                this.handleSpecialFieldStateUpdate_(field);
            }
        },
        updateFormSubmitLabel_(buttonLabel) {
            this.updateState(state => {
                state.formSubmitLabel = buttonLabel;
            });
        },
        isUserTyping() {
            return this.data.fields.some(field => field.userTyping);
        },
        sendEventWithName(eventName, eventData = {}) {
            this.sendEvent_(this.getEventByName_(eventName), eventData);
        },
        updateFormContentClasses(baseClass, baseCondition) {
            this.updateBaseClasses_('contentBaseClasses', baseClass, baseCondition);
        },
        updateFormRootClasses(baseClass, baseCondition) {
            this.updateBaseClasses_('rootBaseClasses', baseClass, baseCondition);
        },
        updateState(stateModifier) {
            stateModifier(this.state);
            const state = Object.create(this.state);
            this.state = state;
            formStore.updateFormState(state);
        },
        validateFields() {
            const validFields = this.registeredFields.filter(field => {
                if (field.ignore
                    || (field.state && !field.state.connected)) {
                    return true;
                }

                if ("isValid" in field) {
                    return field.isValid;
                }

                return true;
            });

            if (!this.state.formReadyForSubmit
                && validFields.length === this.registeredFields.length) {
                this.updateState(state => state.formReadyForSubmit = true);
            } else {
                this.updateState(state => state.formReadyForSubmit = false);
            }
        }
    }
};